import { Navigate } from 'react-router-dom';
import { getPPEServicesToken } from '../../api/eppsService';

// MDM is reachable only through the /deep-link handshake, which stores the
// opaque service token in (per-tab) sessionStorage before redirecting here.
// A directly-typed URL opens in a fresh tab with no token, so block it and
// send the user back to the deep-link entry point.
const hasValidDeepLinkToken = () => {
  const token = getPPEServicesToken();
  return Boolean(token && token !== 'null' && token !== 'undefined');
};

const DeepLinkGuard = ({ children }: { children: React.ReactNode }) => {
  if (!hasValidDeepLinkToken()) {
    return <Navigate to="/deep-link" replace />;
  }
  return <>{children}</>;
};

export default DeepLinkGuard;